<h3 mat-dialog-title>Are you sure you want to remove this payment method?</h3>
<div mat-dialog-actions  align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button color="warn"[mat-dialog-close]="data" cdkFocusInitial>Yes</button>
</div>
